module.exports = __webpack_public_path__ + "img/contact.d30e846a.png";